export const formKeyToFormLabel = (formKeys: string[], counter: number) => {
  return formKeys[counter]
    .replace("_", " ")
    .split(" ")
    .map((eachWord) => eachWord.charAt(0).toUpperCase() + eachWord.slice(1))
    .join(" ");
};
